import { render, staticRenderFns } from "./ConfirmCart.vue?vue&type=template&id=2ca995fd&scoped=true"
import script from "./ConfirmCart.vue?vue&type=script&lang=ts"
export * from "./ConfirmCart.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmCart.vue?vue&type=style&index=0&id=2ca995fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca995fd",
  null
  
)

export default component.exports